<template>
  <v-main class="pt-12">
    <v-layout v-if="!isAdmin">
      <agent-layout refs="layout"></agent-layout>
    </v-layout>
    <v-layout v-else>
      <admin-layout refs="layout"></admin-layout>
    </v-layout>
  </v-main>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AdminLayout from './AdminLayout'
    import AgentLayout from './AgentLayout'

    export default {
        components: {AgentLayout, AdminLayout},
        name: 'DashboardHome',
        data() {
            return {}
        },
        computed: {
            ...mapGetters('auth', [
                'isAdmin'
            ])
        }
    }
</script>